module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8BAMAAADI0sRBAAAAJFBMVEUAAAB8SyWAUCB9SiV8SySASCh8SyR9SiV8SyN8SyR7SyR8SyQBETKeAAAAC3RSTlMAoBDf0CC/YJCAcNj2td0AAACISURBVDjL7cuxCYAwFIThh2BvZWMluEVGsHQIcQt7e2tXSGWR5QyJeMJxmSB/9XjHZ7WarDnX0jyFsBfwHIIv4VhXwolL7F3kGndL4gpbC844DokrbJlLnLnC4AKDMwaXGJwxuMTgjMEJM2cMTpg5sOQD4cTv93TA4HgejCP/9LgZ1/aX1Wr/HtlPX2jIGlhcAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/resource/vl_1.png
// module id = +HgK
// module chunks = 1